namespace Matrix.Visualizer {
    export interface GraphDataResponse extends Serenity.ServiceResponse {
        Graph?: GraphRow;
        Theme?: GraphThemeRow;
        Edges?: GraphEdgeRow[];
        Nodes?: GraphNodeRow[];
        GraphInstanceId?: number;
        GraphKey?: string;
        InstanceKey?: string;
        ThemeKey?: string;
    }
}
